import { useFormContext } from 'react-hook-form'
import { BasicInput } from '@/view/components/BasicInput'
import BasicOptions from '@/view/components/BasicOptions'
import { BasicSelect } from '@/view/components/BasicSelect'
import { Button } from '@/view/components/ui/button'
import { CreditClientFormData } from './schema'
import { customStyles } from './CustomStyles'

interface BankInfoStepProps {
  visible: boolean
  onNext: () => void
  onBack: () => void
  banks: { label: string; value: string }[]
}

export function BankInfoStep({
  visible,
  onNext,
  onBack,
  banks,
}: BankInfoStepProps) {
  const {
    register,
    formState: { errors, touchedFields },
    watch,
  } = useFormContext<CreditClientFormData>()

  const handleNext = () => {
    onNext()
  }

  const isFormValid = () => {
    const bankAccount = watch('bankAccount')
    return (
      bankAccount.bank &&
      bankAccount.agency &&
      bankAccount.account &&
      bankAccount.accountType
    )
  }

  const shouldShowError = (
    fieldName: keyof CreditClientFormData['bankAccount'],
  ) => {
    return (
      touchedFields.bankAccount?.[fieldName] &&
      errors.bankAccount?.[fieldName]?.message
    )
  }

  if (!visible) return null

  return (
    <div className="flex flex-col">
      <div className="mb-5">
        <h1 className="mb-2 text-xl font-semibold text-black01 sm:text-2xl">
          Informe os dados da conta bancária que receberá a transferência
        </h1>
      </div>
      <div className="w-full space-y-4">
        <BasicOptions
          name="bankAccount.accountType"
          options={[
            { label: 'Conta Corrente', value: 'CC' },
            { label: 'Conta Poupança', value: 'CP' },
          ]}
          label="Tipo de conta"
          error={
            shouldShowError('accountType')
              ? errors.bankAccount?.accountType?.message
              : undefined
          }
        />

        <div>
          <BasicSelect
            name="bankAccount.bank"
            label="Banco"
            options={banks}
            placeholder="Selecione seu banco"
            styles={customStyles}
            error={
              shouldShowError('bank')
                ? errors.bankAccount?.bank?.message
                : undefined
            }
          />
        </div>
        <div className="flex items-center gap-4">
          <BasicInput
            {...register('bankAccount.agency')}
            label="Agência"
            placeholder="0000"
            error={
              shouldShowError('agency')
                ? errors.bankAccount?.agency?.message
                : undefined
            }
            type="text"
          />

          <BasicInput
            {...register('bankAccount.account')}
            label="Conta"
            placeholder="00000-0"
            error={
              shouldShowError('account')
                ? errors.bankAccount?.account?.message
                : undefined
            }
            type="text"
          />
        </div>
      </div>

      <div className="mt-44 flex w-full items-center justify-center gap-4">
        <Button
          type="button"
          variant="outline"
          onClick={onBack}
          className="w-full rounded-full bg-gray01 px-8 py-3"
        >
          Voltar
        </Button>
        <Button
          type="button"
          onClick={handleNext}
          disabled={!isFormValid()}
          className="w-full rounded-full bg-primary px-8 py-3"
        >
          Continuar
        </Button>
      </div>
    </div>
  )
}
